import { openUniDirectionalChannel } from '../utils';
import { RELOAD } from '../constants';
var reload = () => {
  openUniDirectionalChannel({
    type: RELOAD
  });
};
export default reload;